<template>
  <input-base
    :overlap="overlap"
    :small="small"
    :transparent="transparent"
    :stretched="stretched"
    :slimmer="slimmer">

    <label
      slot="label"
      v-if="!!inputLabel"
      :for="inputName">

      {{ inputLabel }}
    </label>

    <div
      :class="`${getInnerStyle} ${getExtraStyle}`"
      slot="input">

      <select
        :id="identification"
        :name="inputName"
        v-model="selected"
        @change="sendUpdate()"
        :disabled="dissabled"
        :class="{dissabled}">
        
          <option
            v-for="(opt, i) in getFullList"
            :key="`${opt.val}${i}`"
            :class="optionClassName"
            :value="opt.val">

            {{ $t(opt.label) }}
        </option>
      </select>
    </div>
  </input-base>
</template>

<script>
import InputBase from '@/components/standard/input/InputBase'
import stylers from '@/mixins/components/standard/input/inputButton/stylers'
import '@/assets/styles/standardInputs.css'
import inputValidator from '@/mixins/standard/input/inputValidator'

const DEFAULT_VALUE = 'dft'

export default {
  data () {
    return {
      extraFields: {},
      selected: this.defaultValue || DEFAULT_VALUE
    }
  },

  methods: {
    /**
     * Extracts extra values to be passed along with option's value
     * @param {Array} options Select options
     */
    extractExtraFields (options) {
      this.$set(this, 'extraFields', {})
      for (let opt of options) {
        if (opt.sideVal) { this.$set(this.extraFields, opt.val, opt.sideVal) }
      }
    }
  },

  computed: {
    /**
     * Gives extra style for dropdown
     * @returns {String}
     */
    getExtraStyle () {
      let rtr = ''
      if (this.variant === 'standardInput') rtr += 'q-arrow'
      return rtr
    },

    /**
     * Gives input's side value
     * @returns {*}
     */
    getSideValue () {
      return this.extraFields[this.getInputValue]
    },

    /**
     * GIves input value
     * @returns {String|null}
     */
    getInputValue () {
      if (this.selected === DEFAULT_VALUE) return null
      return this.selected
    },

    /**
     * Gives array of items to be displayed
     * @returns {Array}
     */
    getFullList () {
      let pHolder = []
      if (this.inputPlaceholder) {
        pHolder = [{ label: this.getPlaceholderLabel, val: 'dft' }]
      }

      return (pHolder).concat(this.selectOptions)
    }
  },

  props: {
    optionClassName: {
      type: String,
      required: false,
      default: ''
    },
    selectOptions: {
      type: Array,
      required: true,
      default: () => []
    },
    defaultValue: {
      required: false,
      default: null
    }
  },

  watch: {
    defaultValue (val) {
      this.selected = val || DEFAULT_VALUE
    },

    getFullList (val) {
      this.extractExtraFields(this.selectOptions)
    }
  },

  mixins: [
    stylers,
    inputValidator
  ],

  components: {
    'input-base': InputBase
  }
}
</script>

<style scoped>
/* Overwride the standard base -- Apply offsets to select */
.standard-inner-input-style {
  padding: 0!important;
}
.standard-inner-input-style select {
  padding: 0 15px!important;
}

select {
  background-color: #FFF;
  border: 0;
  outline: 0;
  width: 100%;
  height: 100%;

  -moz-appearance: none;
  -webkit-appearance:none;
}
select::-ms-expand {
  display: none;
}

.q-arrow{
  overflow: hidden;
  position: relative;
  padding: 10px 0;
  min-width: 130px;
}
.q-arrow:after{
  width: 0; 
  height: 0; 
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #7AC143;
  position: absolute;
  top: 40%;
  right: 10px;
  content: "";
  z-index: 1;
 }
.q-arrow select{
  border: 0;
  position: relative;
  background: none;
}
.small {
  padding-top: 1px!important;
  padding-bottom: 1px!important;
  height: 27px!important;
}
.smaller {
  padding-top: 4px!important;
  padding-bottom: 4px!important;
  height: 32px!important;
}

.dissabled {
  cursor: not-allowed;
}

</style>




// WEBPACK FOOTER //
// src/components/standard/input/InputSelect.vue?2e811d16